export const FETCH_SPACE_MEMBERS_BY_ROLE = 'organization/spaces/members/roles/GET'
export const FETCH_SPACE_MEMBERS_BY_ROLE_SUCCESS = `${FETCH_SPACE_MEMBERS_BY_ROLE}_SUCCESS`

export const FETCH_SPACE_MEMBERS_BY_NOT_ROLE = 'organization/spaces/members/not/roles/GET'
export const FETCH_SPACE_MEMBERS_BY_NOT_ROLE_SUCCESS = `${FETCH_SPACE_MEMBERS_BY_NOT_ROLE}_SUCCESS`

export const ADD_SPACE_MEMBER_FROM_ROLE = 'organization/spaces/members/roles/ADD'
export const ADD_SPACE_MEMBER_FROM_ROLE_SUCCESS = `${ADD_SPACE_MEMBER_FROM_ROLE}_SUCCESS`

export const REMOVE_SPACE_MEMBER_FROM_ROLE = 'organization/spaces/members/roles/REMOVE'
export const REMOVE_SPACE_MEMBER_FROM_ROLE_SUCCESS = `${REMOVE_SPACE_MEMBER_FROM_ROLE}_SUCCESS`

export const RESET_SPACE_MEMBERS_ROLES_PAGINATION_STATE = 'organization/spaces/members/roles/RESET'
